import script from "./DetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailModal.vue?vue&type=script&setup=true&lang=js"

import "./DetailModal.vue?vue&type=style&index=0&id=1490859c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1490859c"]])

export default __exports__